import Api from '../Api'
import store from '@/store/store'

export default {
    // READ ALL - Mes bénéficiaires
    getAllBeneficiaries() {
        return Api().post('beneficiaries/getone', {
            userid: store.state.user._id
        })
    },

    // CREATE - Créer un bénéficiaire
    createBeneficiary(beneficiaryData) {
        return Api().post('beneficiaries/create', {
            userid: store.state.user._id,
            ...beneficiaryData
        })
    },

    // UPDATE - Modifier un bénéficiaire
    updateBeneficiary(id, beneficiaryData) {
        return Api().post('beneficiaries/update', {
            userid: store.state.user._id,
            id,
            ...beneficiaryData
        })
    },

    // DELETE - Supprimer un bénéficiaire
    deleteBeneficiary(id) {
        return Api().post('beneficiaries/delete', {
            id
        })
    }
}
